import {DeepLinkActionBase} from '../deep-link-action-base';
import {IDeepLinkActionChain} from '../deep-link-action-chain';
import {PlayGameRealDeepLinkAction} from '../play-game/play-game-real/play-game-real-deeplink-action';
import {PlayGameDemoDeepLinkAction} from '../play-game/play-game-demo/play-game-demo-deeplink-action';

export class RegisterDeepLinkAction extends DeepLinkActionBase {

  async execute(): Promise<void> {
    this.services.dialog.closeAllDialogs();
    await this.services.externalLinks.openMembership({
      marketingParams: this.descriptor.marketingParams
    });
  }



  private _findNextActionOfType(actionType: any): IDeepLinkActionChain | null {
    let next = this.nextAction;
    while(next) {
      if(this.services.deepLinkActionsFactory.isActionOfType(next, actionType)) {
        return next;
      } else {
        next = next.nextAction;
      }
    }

    return null;
  }

  private _playGame() {
    let nextAction = this._findNextActionOfType(PlayGameRealDeepLinkAction);
    if(nextAction) {
      return nextAction.execute();
    }

    nextAction = this._findNextActionOfType(PlayGameDemoDeepLinkAction);
    if(nextAction) {
      return nextAction.execute();
    }
    return Promise.resolve();
  }
}
